import { TAppState } from '../../types/appState';

export const clientEventsSelector = (state: TAppState) => state.socket.clientEvents;
